/**
 * Firebase Storage helper utilities
 */

/**
 * Strips the download `token` query param from a Firebase Storage URL,
 * yielding a stable, path-based URL (e.g. `…/o/performers%2Fabc.jpg?alt=media`).
 *
 * Re-uploading to the same storage path regenerates the download token and
 * invalidates the previous one, which 403s any URL still carrying the old
 * token. A tokenless URL always resolves to whatever currently lives at the
 * path, so denormalized copies (e.g. on event records) never break — provided
 * the path is publicly readable in storage.rules.
 *
 * @param {string} url - A Firebase Storage download URL.
 * @returns {string} The same URL without its `token` param (no-op if absent).
 */
export function toStableUrl(url) {
  if (!url || typeof url !== "string") return url;
  try {
    const u = new URL(url);
    u.searchParams.delete("token");
    return u.toString();
  } catch (e) {
    return url;
  }
}
